import React from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { HiDotsHorizontal } from "react-icons/hi";
import { CommunityProps } from "../../types";
import { GET_COMMUNITIES } from "../../apollo/operations";
import { useQuery } from "@apollo/client";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { Link } from "react-router-dom";
import { Astro } from "../../assets/images";
import { EcoBookCard } from "../../components";

const ProfileCommunity: React.FC = () => {
  const [userCommunity, setUserCommunity] = React.useState<
    CommunityProps[] | undefined
  >();
  const { loading, error } = useQuery(GET_COMMUNITIES, {
    onCompleted: (data) => {
      console.log(data);
      setUserCommunity(data.communities);
    },
    notifyOnNetworkStatusChange: true,
    onError: (err) => {
      console.log(err);
    },
  });

  const userId = window.localStorage.getItem("user");

  const userIsAMember = userCommunity?.filter((community) => {
    // Check if the user is not a member of the community
    const isNotMember = community.members.some(
      (member) => member?.id === userId
    );
    return isNotMember;
  });
  const [active, setActive] = React.useState<number | null>(null);
  const [openOption, setOpenOption] = React.useState(null);
  //This is used for filtering the communities the user does not belong to.
  const communitiesNotMemberOf = userCommunity?.filter((community) => {
    // Check if the user is not a member of the community
    const isNotMember = !community.members.some(
      (member) => member?.id === userId
    );
    return isNotMember;
  });

  const handleToggle = (index: any) => {
    setOpenOption((prev) => (prev === index ? null : index));
  };

  const handleActive = (index: number) => {
    setActive(index);
  };

  return (
    <div className="flex flex-row justify-between bg-white lg:bg-inherit mt-4 lg:mt-0 py-7 lg:py-0">
      <div className="flex flex-col gap-3 lg:w-[67.5%] w-full lg:px-0 px-5">
        <div className="text-searchCol font-Poppins lg:mt-7 mt-0 text-[9px] ">
          Your Communities
        </div>
        <div className="grid grid-cols-2 gap-3 ">
          {userIsAMember &&
            userIsAMember?.map((com, index) => (
              <EcoBookCard community={com} key={index * 2} />
            ))}
        </div>
      </div>
      <div className="bg-white rounded shadow py-3 px-2 w-[31%] hidden lg:flex flex-col h-fit">
        <div className="flex justify-between items-center mb-3">
          <h1 className="font-Poppins text-[9.1px] text-[#8E9297]">
            Sugested Communities
          </h1>
          <div className="w-6 h-6 items-center pl-[6px] flex rounded-full bg-[rgba(33,87,89,0.05)]">
            <AiOutlinePlus size={12} className="fill-midGreen" />
          </div>
        </div>
        <div className="grid gap-3 items-center rounded-sm">
          {communitiesNotMemberOf?.map((com, index) => {
            return (
              <Link to={`/ecobook/community/${com.name}/${com.id}`}>
                <div
                  className={`relative flex items-center justify-between pr-2 cursor-pointer ${
                    active === index
                      ? "bg-midGreen h-9 transition-all rounded ease-linear duration-150"
                      : ""
                  }`}
                  key={com.id}
                  onClick={() => handleActive(index)}
                >
                  <div className="flex h-8 justify-between gap-2 items-center">
                    <div className="">
                      <img
                        alt=""
                        src={
                          com.communityHeaderImgUrl
                            ? ipfsGatewayImage(com.communityHeaderImgUrl)
                            : Astro
                        }
                        className={`w-7 h-7 rounded-full ${
                          active === index ? "ml-2 mb-px" : ""
                        }`}
                      />
                    </div>
                    <div className="flex flex-col justify-between">
                      <h4
                        className={`font-Poppins text-[12.5px] font-semibold ${
                          active === index ? "text-white" : "text-lightBlack"
                        }`}
                      >
                        {com?.name}
                      </h4>
                      <p
                        className={`font-Poppins font-normal details text-[8px] ${
                          active === index
                            ? "text-whiteMode"
                            : "text-lightGreyText"
                        }`}
                      >
                        {com?.description.slice(0, 28)}
                      </p>
                    </div>
                  </div>
                  <HiDotsHorizontal
                    size={13}
                    className={`${
                      active === index
                        ? "fill-white cursor-pointer"
                        : "fill-lightGreyText"
                    } `}
                    onClick={() => handleToggle(index)}
                  />
                  {/* {openOption === index && (
                <div className="absolute top-full right-[-20px] flex flex-col items-center">
                  <div className="border-l-[8px] w-[10px] border-r-[8px] border-l-transparent border-r-transparent border-b-[#000] border-b-[10px] border-solid"></div>
                  <ul
                    className='shadow bg-[#000] text-white mt-0 rounded whitespace-nowrap font-Poppins text-center justify-center text-xs'
                  >
                    <button className='p-3' type="button" onClick={handleJoin}>Join</button>
                  </ul>
                </div>
              )} */}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProfileCommunity;
